function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import utils from '@/js/utils';
import tasks from '@/js/tasks';
import ProfilingTableResult from '@/components/profiling/ProfilingTableResult';
import BaseLoading from '@/components/BaseLoading';
import AssignmentsService from '@/apps/data-platform/services/tables_views/assignments_service';
import DataProfilingService from '@/apps/data-platform/services/data_quality/data_profiling_service';
import FilesService from '@/apps/data-platform/services/security/files_service';
import user_security_service from '@/apps/data-platform/services/security/user_security_service';
import TabMetadataBusinessTermsComponent from '@/apps/data-platform/components/TabMetadataBusinessTermsComponent.vue';
var LineageComponent = function LineageComponent() {
  return import('@/components/lineage/LineageComponent.vue');
};
import ListTableLogs from '@/components/ListTableLogs.vue';
import ListTableMetadataCols from '@/apps/data-platform/components/ListTableMetadataColsComponent.vue';
import { createEmailDomainValidator } from '@/js/emailDomainValidator';
import { downloadTableMetadataTemplate as buildTableMetadataCsv, downloadColumnMetadataTemplate as buildColumnMetadataCsv } from '@/js/metadata_templates';
import { ROLES_LIST, DEFAULT_TPL_FIELDS, DEFAULT_TPL_COLUMNS, TYPE_CHANGE_METADA, ACCESS_TYPE_FLOW, METADATA_FILE_FORMAT, METADATA_IMAGE_FORMAT, PATTERNS_VALIDATION, BUCKET_DIRECTORY_TYPES, GA_EVENTS, isFOHDomain } from '@/js/constants';
var EMAIL_FORMAT = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export default {
  name: 'FormMetadata',
  props: {
    tplToWork: {
      type: Object,
      required: true
    },
    // isChangeRequest: is most important define that show and end submit function
    isChangeRequest: {
      type: String,
      required: false,
      default: TYPE_CHANGE_METADA.UPDATE
    },
    isReferenceView: {
      type: Boolean
    },
    isSynapse: {
      type: Boolean,
      required: false,
      default: false
    },
    source: {
      type: String,
      required: false,
      default: 'bigquery'
    }
  },
  components: {
    BaseLoading: BaseLoading,
    ProfilingTableResult: ProfilingTableResult,
    TabMetadataBusinessTermsComponent: TabMetadataBusinessTermsComponent,
    LineageComponent: LineageComponent,
    ListTableLogs: ListTableLogs,
    ListTableMetadataCols: ListTableMetadataCols
  },
  data: function data() {
    var _this = this;
    return {
      operatorValidator: createEmailDomainValidator(user_security_service.validateEmailDomain),
      busDataStewardValidator: createEmailDomainValidator(user_security_service.validateEmailDomain),
      dataOwnerValidator: createEmailDomainValidator(user_security_service.validateEmailDomain),
      techDataCustodiamValidator: createEmailDomainValidator(user_security_service.validateEmailDomain),
      authorizationType: 'manual',
      current: '',
      cDomain: '',
      cEmail: '',
      cRoles: [],
      validUserAccess: true,
      tableRoles: null,
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      DEFAULT_TPL_FIELDS: DEFAULT_TPL_FIELDS,
      DEFAULT_TPL_COLUMNS: DEFAULT_TPL_COLUMNS,
      DEFAULT_TPL_FILEDS_AREA_ENUM: [],
      DEFAULT_TPL_FILEDS_ZONE_ENUM: [],
      METADATA_FILE_FORMAT: METADATA_FILE_FORMAT,
      METADATA_IMAGE_FORMAT: METADATA_IMAGE_FORMAT,
      PATTERNS_VALIDATION: PATTERNS_VALIDATION,
      showLineageStatus: false,
      defaultFields: {},
      submitButton: null,
      TYPE_CHANGE_METADA: TYPE_CHANGE_METADA,
      columnFields: [],
      // response from Api
      defaultFields_original: [],
      // for compare requests
      columnFields_original: [],
      // for compare requests
      columnFieldsLabels: [{
        key: 'column',
        sortable: true
      }, {
        label: 'Description',
        key: 'description'
      }, {
        label: 'Sensitive',
        key: 'sensitive',
        sortable: true
      }, 'null', 'primary_key', 'business_definition', 'data_element_name', 'dataset', 'field', 'length', 'table', 'transformation_logic', 'type', 'valid_values'],
      filter: null,
      filterOn: [],
      files: [],
      isLoading: false,
      currentEnv: 0,
      currentFile: {},
      selected_area: '',
      selected_zone: '',
      dismissCountDown: 0,
      dismissSecs: 8,
      dangerMessage: '',
      inputUploadFile: null,
      // to
      relativeResourceName: '',
      domain_table: '',
      selectProfilingRules: [],
      profilingRuleSelected: {},
      isLoadingProfilingRules: true,
      isLoadingExecutions: true,
      valid: true,
      tab: null,
      requiredFlag: null,
      currentRule: null,
      MAX_CHARACTERS: 2000,
      DESC_CHARACTERS_COUNT: 0,
      key_description: 1,
      completeDescription: '',
      MAX_CHARACTERS_DATA_CATALOG: 2000,
      rules: {
        required: function required(v) {
          return !!v || _this.$t('my_tasks.modals.required');
        },
        emailFormat: function emailFormat(v) {
          return EMAIL_FORMAT.test(v) || _this.$t('my_tasks.modals.email_invalid');
        },
        validateEmail: function validateEmail(v) {
          if (_this.isFOH && (!v || v.toLowerCase() == 'null')) {
            return _this.$t('my_tasks.modals.required');
          }
          if (v && v.toLowerCase() != 'null' && !EMAIL_FORMAT.test(v)) {
            return _this.$t('my_tasks.modals.email_invalid');
          }
          return true;
        },
        emailRequired: function emailRequired(v) {
          console.log('validate email required: ', v);
          if (_this.isFOH && (!v || v === 'Null')) {
            console.log('email is required');
            return _this.$t('my_tasks.modals.required');
          }
          if (v && v !== 'Null' && !EMAIL_FORMAT.test(v)) {
            console.log('email format is invalid');
            return _this.$t('my_tasks.modals.email_invalid');
          }
          return true;
        }
      }
    };
  },
  watch: {
    authorizationType: function authorizationType(val) {
      if (this.defaultFields && this.defaultFields.authorization_type) {
        this.defaultFields.authorization_type.stringValue = val;
      }
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('data-platform', ['select_areas', 'select_zones', 'organizations', 'selectDomain', 'selectSubdomain'])), mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    isTableOwnerLogged: function isTableOwnerLogged() {
      return this.tableRoles && this.tableRoles.OWNER === this.userEmail;
    },
    // Reglas FOH del flujo de asignación de owner (defaults + campos bloqueados);
    // en entorno local se activan para poder probarlas
    isFohAssignmentFlow: function isFohAssignmentFlow() {
      return this.isChangeRequest === TYPE_CHANGE_METADA.OWENER_FLOW && (isFOHDomain(this.userInfo.domain) || process.env.VUE_APP_ENV === 'local' || process.env.NODE_ENV === 'development');
    },
    isPublicTable: function isPublicTable() {
      var isPublic = this.defaultFields[DEFAULT_TPL_FIELDS.PUBLIC.name].boolValue;
      if (!isPublic) {
        // eslint-disable-next-line
        this.defaultFields[DEFAULT_TPL_FIELDS.AREA.name].stringValue = 'general';
      }
      return this.defaultFields[DEFAULT_TPL_FIELDS.PUBLIC.name].boolValue;
    },
    authorizationTypeOptions: function authorizationTypeOptions() {
      return [{
        text: this.$t('my_tasks.modals.authorization_type_manual'),
        value: 'manual'
      }, {
        text: this.$t('my_tasks.modals.authorization_type_automatic'),
        value: 'automatic'
      }];
    },
    // filter subdomain from domain
    filterSubdomain: function filterSubdomain() {
      var domain_text = this.defaultFields[DEFAULT_TPL_FIELDS.DOMAIN.name].stringValue;
      var domain_element = this.selectDomain.find(function (e) {
        return e.text === domain_text;
      });
      var subdomains = domain_element ? this.selectSubdomain.filter(function (Subdomain) {
        return Subdomain.domain === domain_element.kdomain;
      }) : [];
      console.log(domain_text);
      console.log(subdomains);
      return subdomains;
    },
    unicodeCharLimit: function unicodeCharLimit() {
      return utils.getUtf8ByteSize(this.defaultFields[DEFAULT_TPL_FIELDS.DESCRIPTION.name].stringValue) <= this.MAX_CHARACTERS || "M\xE1ximo ".concat(this.MAX_CHARACTERS, " caracteres permitidos");
    },
    isFOH: function isFOH() {
      console.log(' IS FOH:', isFOHDomain(this.userInfo.domain));
      return isFOHDomain(this.userInfo.domain);
    },
    showAuthorizationType: function showAuthorizationType() {
      if (process.env.VUE_APP_ENV === 'prod') {
        return this.isFOH;
      }
      return this.userInfo.domain === 'intercorp.com.pe';
    }
  }),
  created: function created() {
    if (isFOHDomain(this.userInfo.domain) || this.userInfo.domain == 'intercorp.com.pe') {
      this.MAX_CHARACTERS = 5000;
    }
    console.log('data: ', this.tplToWork);
    console.log('formsynap:', this.source);
    console.log('domains:', this.selectDomain);
    this.userInfo = tasks.getUserInfo();
    this.cDomain = this.userInfo.domain;
    this.cEmail = this.userInfo.email;
    this.cRoles = this.userInfo.userRoles;
    // Separe defaultTemplate and Columnfields
    if (!this.tplToWork.objects || !this.tplToWork.objects.tags) {
      return undefined;
    }
    var separeValues = tasks.filterDefaultTableTagsAndColumnFields(this.tplToWork.objects.tags);
    this.relativeResourceName = this.tplToWork.item.relativeResourceName;
    this.domain_table = this.tplToWork.item.domain_table || this.tplToWork.item.domain;
    this.defaultFields = separeValues.defaultFields;
    this.columnFields = separeValues.columnFields;
    // Defaults de asignación: solo dominios FOH y, para poder probarlo, entorno local
    if (this.isFohAssignmentFlow) {
      this.applyAssignmentDefaults();
    }
    this.fvalidUserAccess();
    if (this.defaultFields.authorization_type) {
      this.authorizationType = this.defaultFields.authorization_type.stringValue || 'manual';
    }

    // preserve original for pre submit validations comparing
    this.defaultFields_original = utils.cloneJSON(separeValues.defaultFields);
    this.columnFields_original = utils.cloneJSON(separeValues.columnFields);

    // set copy owner and stewards
    this.tableRoles = utils.getOwnersAndStewards(this.defaultFields);
    this.files = this.parseFiles();
    this.currentEnv = this.defaultFields[DEFAULT_TPL_FIELDS.ENVIRONMENT.name].enumValue.displayName;
    if (this.domain_table !== this.userDomain) {
      this.$store.dispatch('data-platform/getSelectFields', this.domain_table);
    }
    console.log('items:', this.defaultFields);
    this.completeDescription = this.defaultFields[DEFAULT_TPL_FIELDS.DESCRIPTION.name].stringValue + (this.defaultFields[DEFAULT_TPL_FIELDS.DESCRIPTION2.name] && this.defaultFields[DEFAULT_TPL_FIELDS.DESCRIPTION2.name].stringValue != 'Null' ? this.defaultFields[DEFAULT_TPL_FIELDS.DESCRIPTION2.name].stringValue : '') + (this.defaultFields[DEFAULT_TPL_FIELDS.DESCRIPTION3.name] && this.defaultFields[DEFAULT_TPL_FIELDS.DESCRIPTION3.name].stringValue != 'Null' ? this.defaultFields[DEFAULT_TPL_FIELDS.DESCRIPTION3.name].stringValue : '');
    this.handleInput(this.completeDescription);
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.commit('data-platform/setProfilingExecutions', []);
    this.$store.commit('data-platform/setProfilingExecution', {});
    if (this.domain_table !== this.userDomain) {
      this.$store.dispatch('data-platform/getSelectFields', this.userDomain);
    }
  },
  methods: {
    // Descargas en formato de plantilla de carga masiva FOH (campo-valor / columnas)
    downloadTableMetadataTemplate: function downloadTableMetadataTemplate() {
      buildTableMetadataCsv(this.tplToWork.item.tableReference, this.defaultFields);
    },
    downloadColumnMetadataTemplate: function downloadColumnMetadataTemplate() {
      buildColumnMetadataCsv(this.tplToWork.item.tableReference, this.columnFields);
    },
    // Precarga defaults en el flujo de asignación de owner cuando los tags vienen vacíos.
    // Los tipos/longitud/nulo salen del esquema real de BigQuery, que la página de
    // asignaciones ya mezcló en la fila (getTablesDetails → tplToWork.item.schema).
    applyAssignmentDefaults: function applyAssignmentDefaults() {
      var _this2 = this;
      var isEmpty = function isEmpty(v) {
        return v === undefined || v === null || v === '' || v === 'Null';
      };
      var orgField = this.defaultFields[DEFAULT_TPL_FIELDS.ORGANIZATION.name];
      if (orgField && isEmpty(orgField.stringValue)) {
        // Candidatos: nombre de la empresa del usuario y code/domain de su org
        // (userInfo.orgs es [{code, domain}]); se usa el primero que exista en la
        // lista de organizaciones del dominio, que es lo que valida el select.
        var userOrg = (window.userInfo && window.userInfo.orgs || []).find(function (o) {
          return o.domain === (window.userInfo && window.userInfo.domain);
        }) || {};
        var candidates = [this.companyName, userOrg.code, userOrg.domain];
        var match = candidates.find(function (c) {
          return c && _this2.organizations.includes(c);
        });
        if (match) {
          orgField.stringValue = match;
        } else if (this.organizations.length === 1) {
          orgField.stringValue = this.organizations[0];
        }
      }

      // En FOH las tablas asignadas son siempre públicas (campo bloqueado en el form)
      var publicField = this.defaultFields[DEFAULT_TPL_FIELDS.PUBLIC.name];
      if (publicField) {
        publicField.boolValue = true;
      }
      var areaField = this.defaultFields[DEFAULT_TPL_FIELDS.AREA.name];
      if (areaField && isEmpty(areaField.stringValue)) {
        areaField.stringValue = 'general';
      }
      var schemaFields = this.tplToWork.item && this.tplToWork.item.schema && this.tplToWork.item.schema.fields || [];
      var schemaByName = {};
      schemaFields.forEach(function (f) {
        schemaByName[f.name.toLowerCase()] = f;
      });
      this.columnFields.forEach(function (tag) {
        var schemaField = tag.column && schemaByName[tag.column.toLowerCase()];
        if (!schemaField) return;
        var typeField = tag.fields[DEFAULT_TPL_COLUMNS.TYPE.name];
        if (typeField && isEmpty(typeField.stringValue)) {
          typeField.stringValue = schemaField.type;
        }
        var lengthField = tag.fields[DEFAULT_TPL_COLUMNS.LENGTH.name];
        if (lengthField && isEmpty(lengthField.stringValue)) {
          lengthField.stringValue = String(schemaField.length || schemaField.maxLength || schemaField.precision || 0);
        }
        var nullField = tag.fields[DEFAULT_TPL_COLUMNS.NULL.name];
        if (nullField && nullField.boolValue == null) {
          nullField.boolValue = schemaField.nullable !== undefined ? !!schemaField.nullable : schemaField.mode !== 'REQUIRED';
        }
      });
    },
    validateEmailsDomainsBeforeSubmit: function () {
      var _validateEmailsDomainsBeforeSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var fields, _i, _fields, _fields$_i, name, validator, value;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              fields = [['OPERATOR', this.operatorValidator], ['BUS_DATA_STEWARD', this.busDataStewardValidator], ['DATA_OWNER', this.dataOwnerValidator], ['TECH_DATA_CUSTODIAM', this.techDataCustodiamValidator]];
              _i = 0, _fields = fields;
            case 1:
              if (!(_i < _fields.length)) {
                _context.n = 6;
                break;
              }
              _fields$_i = _slicedToArray(_fields[_i], 2), name = _fields$_i[0], validator = _fields$_i[1];
              if (this.defaultFields[this.DEFAULT_TPL_FIELDS[name].name]) {
                _context.n = 2;
                break;
              }
              return _context.a(3, 5);
            case 2:
              value = this.defaultFields[this.DEFAULT_TPL_FIELDS[name].name].stringValue;
              if (!(!value || value === 'Null')) {
                _context.n = 3;
                break;
              }
              return _context.a(3, 5);
            case 3:
              _context.n = 4;
              return validator.validate(value);
            case 4:
              if (validator.state.valid) {
                _context.n = 5;
                break;
              }
              return _context.a(2, false);
            case 5:
              _i++;
              _context.n = 1;
              break;
            case 6:
              return _context.a(2, true);
          }
        }, _callee, this);
      }));
      function validateEmailsDomainsBeforeSubmit() {
        return _validateEmailsDomainsBeforeSubmit.apply(this, arguments);
      }
      return validateEmailsDomainsBeforeSubmit;
    }(),
    domainRule: function domainRule() {
      return this.operatorValidator.state.valid || this.$t('my_tasks.modals.email_domain_invalid');
    },
    handleInput: function handleInput(event) {
      try {
        var newText = event;
        var newByteCount = utils.getUtf8ByteSize(newText);
        this.DESC_CHARACTERS_COUNT = newByteCount;
      } catch (e) {
        this.DESC_CHARACTERS_COUNT = 0;
        console.log(e);
      }
      this.key_description += 1;
    },
    formatDescription: function formatDescription() {
      var newText = this.completeDescription;
      var newByteCount = utils.getUtf8ByteSize(newText);
      // Si el texto excede los 2000 bytes, dividirlo en 3 partes
      if (newByteCount > this.MAX_CHARACTERS_DATA_CATALOG) {
        var text1 = '';
        var text2 = '';
        var text3 = '';
        var currentText = newText;

        // Primera parte
        while (utils.getUtf8ByteSize(text1) < this.MAX_CHARACTERS_DATA_CATALOG && currentText.length > 0) {
          text1 += currentText[0];
          currentText = currentText.slice(1);
        }

        // Segunda parte
        while (utils.getUtf8ByteSize(text2) < this.MAX_CHARACTERS_DATA_CATALOG && currentText.length > 0) {
          text2 += currentText[0];
          currentText = currentText.slice(1);
        }

        // Tercera parte
        while (utils.getUtf8ByteSize(text3) < this.MAX_CHARACTERS_DATA_CATALOG && currentText.length > 0) {
          text3 += currentText[0];
          currentText = currentText.slice(1);
        }

        // Actualizar los campos de descripción
        this.defaultFields[this.DEFAULT_TPL_FIELDS.DESCRIPTION.name].stringValue = text1;
        if (this.defaultFields[this.DEFAULT_TPL_FIELDS.DESCRIPTION2.name]) {
          this.defaultFields[this.DEFAULT_TPL_FIELDS.DESCRIPTION2.name].stringValue = text2;
        }
        if (this.defaultFields[this.DEFAULT_TPL_FIELDS.DESCRIPTION3.name]) {
          this.defaultFields[this.DEFAULT_TPL_FIELDS.DESCRIPTION3.name].stringValue = text3;
        }
      } else {
        // Si no excede los 2000 bytes, mantener todo en la primera descripción
        this.defaultFields[this.DEFAULT_TPL_FIELDS.DESCRIPTION.name].stringValue = newText;
        if (this.defaultFields[this.DEFAULT_TPL_FIELDS.DESCRIPTION2.name]) {
          this.defaultFields[this.DEFAULT_TPL_FIELDS.DESCRIPTION2.name].stringValue = '';
        }
        if (this.defaultFields[this.DEFAULT_TPL_FIELDS.DESCRIPTION3.name]) {
          this.defaultFields[this.DEFAULT_TPL_FIELDS.DESCRIPTION3.name].stringValue = '';
        }
      }
    },
    copyObject: function copyObject() {
      var aux = {
        relativeResourceName: this.tplToWork.item.relativeResourceName,
        objectId: this.tplToWork.item.id,
        tableReference: this.tplToWork.item.tableReference,
        domain_table: this.tplToWork.item.domain_table,
        domain: this.tplToWork.item.domain,
        index_node: ''
      };
      var objetoJSON = JSON.stringify(aux);
      var objetoCodificado = encodeURIComponent(objetoJSON);
      var link = 'http://localhost:8080' + '/#/ObjectLink/table/' + encodeURIComponent(objetoCodificado);
      console.log(link);
      navigator.clipboard.writeText(link);
    },
    onCloseReference: function onCloseReference() {
      this.is_reference_view = false;
      this.$emit('onReferenceClose');
    },
    openTab: function openTab(formType) {
      var _this3 = this;
      this.current = formType;
      switch (formType) {
        case 'Logs':
          this.$refs.refTableLog.listLogs();
          break;
        case 'Profile':
          DataProfilingService.getProfilingHistory({
            tableReference: this.tplToWork.item.tableReference
          }).then(function (response) {
            _this3.selectProfilingRules = response.data || [];
            _this3.profilingRuleSelected = _this3.selectProfilingRules.length > 0 ? _this3.selectProfilingRules[0] : {};
            _this3.currentRule = _this3.profilingRuleSelected.document_id;
            _this3.getExecutions();
            _this3.isLoadingProfilingRules = false;
          });
          break;
        default:
          break;
      }
    },
    openImage: function openImage(url) {
      var uriObj = {
        name: 'DisplayImage',
        query: {
          uris: url
        }
      };
      var urlNew = this.$router.resolve(uriObj);
      window.open(urlNew.href, '_blank');
    },
    showLineageForm: function showLineageForm() {
      this.showLineageStatus = !this.showLineageStatus;
      return this.showLineageStatus;
    },
    isEdited: function isEdited(FIELD_NAME) {
      return utils.fieldIsEdited(FIELD_NAME, this.tableRoles, this.isChangeRequest);
    },
    getPattern: function getPattern(objEnvironment) {
      return tasks.getPattern(objEnvironment, this.defaultFields);
    },
    getRequired: function getRequired(objEnvironment) {
      return tasks.getRequired(objEnvironment, this.defaultFields);
    },
    validateForm: function validateForm(submitText) {
      var formElement = this.$refs.form;
      var stringValue = this.defaultFields[this.DEFAULT_TPL_FIELDS.OPERATOR.name].stringValue;
      /*
      Object.keys(this.$refs.form.fields).forEach(fieldName => {
            const field = this.$refs.form.fields[fieldName];
            if (!field.value) {
              field.validate(true);
              this.$nextTick(() => {
                field.$el.focus();
              });
            }
          }); */
      this.$refs.offsource.focus();
      console.log('form:', formElement.validate());
      // if (!formElement.checkValidity())
      if (formElement.validate()) {
        this.submitButton = submitText;
        this.onSubmit();
        return true;
      } else {
        return false;
      }
    },
    setToSave: function setToSave() {
      console.log(this.tplToWork.objects.tags);
      var toSave = {
        applicant: this.userEmail,
        fields: this.tplToWork.objects.tags,
        operator: this.defaultFields[this.DEFAULT_TPL_FIELDS.OPERATOR.name].stringValue.toLowerCase(),
        relativeResourceName: this.tplToWork.item.relativeResourceName,
        table_id: this.tplToWork.item.tableReference.tableId,
        type_flow: '',
        tableReference: this.tplToWork.item.tableReference,
        commentary: this.tplToWork.commentary,
        endDate: '',
        index_node: this.tplToWork.item.index_node,
        domain_table: this.tplToWork.item.domain_table,
        // La asignación de tablas no define el tipo de autorización: se conserva
        // el valor existente del tag (no se deriva del campo Público)
        authorization_type: this.defaultFields.authorization_type ? this.defaultFields.authorization_type.stringValue || null : null
      };
      // replace emty to Null
      utils.objectEmptyToNull(toSave.fields);
      return toSave;
    },
    saveChangeRequest: function saveChangeRequest() {
      var _this4 = this;
      console.log('savechangerequest');
      var toSave = this.setToSave();
      var objectToRequest = utils.cloneJSON(toSave);
      objectToRequest.type_flow = this.ACCESS_TYPE_FLOW.CHANGE_METADATA;
      var extraParams = {};
      var params = {
        operator: objectToRequest.operator,
        type_flow: objectToRequest.type_flow,
        table_id: objectToRequest.table_id,
        relativeResourceName: objectToRequest.relativeResourceName,
        commentary: objectToRequest.commentary,
        fields: objectToRequest.fields,
        tableReference: objectToRequest.tableReference,
        endDate: objectToRequest.endDate,
        applicant: this.userEmail,
        extraParams: extraParams,
        index_node: objectToRequest.index_node,
        domain_table: objectToRequest.domain_table,
        authorization_type: objectToRequest.authorization_type
      };
      // send to save object
      AssignmentsService.initApprovalFlow(params).then(function (response) {
        _this4.$emit('submit', response.data);
      }).catch(function (e) {
        utils.printError(e);
        //this.saveChangeRequest()
      });
    },
    saveTags: function saveTags() {
      var _this5 = this;
      var toUpdate = utils.cloneJSON(this.tplToWork);
      var tags = toUpdate.objects.tags;
      var tableReference = toUpdate.item.tableReference;
      var relativeResourceName = toUpdate.item.relativeResourceName;
      var index_node = toUpdate.item.index_node;
      var domain_table = toUpdate.item.domain_table;
      var isSynapse = this.isSynapse;
      var source = this.source;
      utils.objectEmptyToNull(tags);
      var params = {
        tags: tags,
        tableReference: tableReference,
        relativeResourceName: relativeResourceName,
        index_node: index_node,
        domain_table: domain_table,
        isSynapse: isSynapse,
        source: source
      };
      console.log('::: saveTags :::');
      AssignmentsService.updateTags(params).then(function (response) {
        console.log('🔓🔓🔓🔓🔓Data operator changed:');
        tasks.toast.success('Data operator changed');
        _this5.$emit('submit', response.data);
      }).catch(function (e) {
        utils.printError('Soy el error', e);
        _this5.saveTags();
      });
    },
    assignOwner: function assignOwner() {
      var _this6 = this;
      console.log('owner');
      var toSave = this.setToSave();
      // set new temporal owner in metadata (switch fiels)
      this.defaultFields[this.DEFAULT_TPL_FIELDS.OPERATOR.name].stringValue = toSave.operator;

      // set copy later instance new
      var objectToRequest = utils.cloneJSON(toSave);
      objectToRequest.endDate = ''; // only fill field requeriment
      objectToRequest.type_flow = this.ACCESS_TYPE_FLOW.APPROVE_OWNER;
      var extraParams = {};
      var params = {
        operator: objectToRequest.operator,
        type_flow: objectToRequest.type_flow,
        table_id: objectToRequest.table_id,
        relativeResourceName: objectToRequest.relativeResourceName,
        commentary: objectToRequest.commentary,
        fields: objectToRequest.fields,
        tableReference: objectToRequest.tableReference,
        endDate: objectToRequest.endDate,
        applicant: objectToRequest.applicant,
        extraParams: extraParams,
        index_node: objectToRequest.index_node,
        domain_table: objectToRequest.domain_table,
        source: this.source,
        authorization_type: objectToRequest.authorization_type
      };
      // send to listFlow tasks
      AssignmentsService.initApprovalFlow(params).then(function (response) {
        if (response.code === 200) {
          if (!response.success) {
            //this.dismissCountDown = this.dismissSecs
            //this.dangerMessage = response.message

            tasks.toast.error(response.message);
          } else {
            // close all modals
            console.log('asignado', GA_EVENTS.ASSIGN_OPERATOR);
            if (_this6.$gtm.enabled() && window.dataLayer) {
              window.dataLayer.push({
                event: GA_EVENTS.ASSIGN_OPERATOR,
                object: 'table',
                domain_object: objectToRequest.domain_table,
                operator: _this6.stringToHash(objectToRequest.operator),
                company_code: _this6.companyCode,
                id_object: objectToRequest.tableReference.projectId + '.' + objectToRequest.tableReference.datasetId + '.' + objectToRequest.tableReference.tableId,
                hash_email: _this6.stringToHash(userInfo.email),
                module: 'data_platform'
              });
            }
            tasks.toast.success('Successful Request!');
            _this6.$emit('submit', response.data);
          }
        }
      }).catch(function (e) {
        utils.printError(e);
        //this.assignOwner()
      });
    },
    returnPreview: function returnPreview() {
      var returnPreview = utils.cloneJSON(this.tplToWork);
      returnPreview.item.response = this.tplToWork.response;
      var envirnoment = this.defaultFields[DEFAULT_TPL_FIELDS.ENVIRONMENT.name];
      returnPreview.envirnoment = envirnoment && envirnoment.enumValue.displayName;
      this.$emit('submit', returnPreview);
    },
    returnPreviewRefuse: function returnPreviewRefuse() {
      var returnPreviewRefuse = utils.cloneJSON(this.tplToWork);
      // se le asigna nuevamente este item ya que response esta al mismo nivel que item
      returnPreviewRefuse.item.response = this.tplToWork.response;
      this.$emit('refuse', returnPreviewRefuse);
    },
    onSubmit: function () {
      var _onSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(event) {
        var okDomains, type_change, stringDescription, owner, owner_original, ownerValidation, ownerWasChanged, ownerWasAssigned, env_original, env, isChangeEnv, isTestEnvironment, isProdEnvironment, isDevEnvironment, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              console.log("onSubmit");
              if (!this.isFOH) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return this.validateEmailsDomainsBeforeSubmit();
            case 1:
              okDomains = _context2.v;
              if (okDomains) {
                _context2.n = 2;
                break;
              }
              this.dangerMessage = this.$t('my_tasks.modals.email_domain_invalid');
              this.dismissCountDown = this.dismissSecs;
              return _context2.a(2);
            case 2:
              this.formatDescription();
              console.log('submited');
              type_change = [TYPE_CHANGE_METADA.CHANGE_REQUEST, TYPE_CHANGE_METADA.UPDATE, TYPE_CHANGE_METADA.OWENER_FLOW].includes(this.isChangeRequest);
              this.dismissCountDown = 0;
              if (!(type_change && !this.checkInputChanges())) {
                _context2.n = 3;
                break;
              }
              //this.dismissCountDown = this.dismissSecs
              //this.dangerMessage = 'No change has been made to the request'
              tasks.toast.error('No change has been made to the request');
              return _context2.a(2);
            case 3:
              stringDescription = this.defaultFields[this.DEFAULT_TPL_FIELDS.DESCRIPTION.name].stringValue;
              if (!(!stringDescription || !stringDescription.match(new RegExp(this.PATTERNS_VALIDATION.ALPHANUMBER_SPECIAL)))) {
                _context2.n = 4;
                break;
              }
              this.dangerMessage = 'Please check Table Description (The following characters are not allowed (,) (|) and (line break))';
              this.dismissCountDown = this.dismissSecs;
              return _context2.a(2);
            case 4:
              _context2.p = 4;
              if (!(this.isChangeRequest === TYPE_CHANGE_METADA.CHANGE_REQUEST)) {
                _context2.n = 5;
                break;
              }
              this.saveChangeRequest(); // save in ChangeRequest
              _context2.n = 9;
              break;
            case 5:
              if (!(this.isChangeRequest === TYPE_CHANGE_METADA.UPDATE)) {
                _context2.n = 6;
                break;
              }
              this.saveTags(); // save in normal metadata
              _context2.n = 9;
              break;
            case 6:
              if (!(this.isChangeRequest === TYPE_CHANGE_METADA.PREVIEW_OWNER)) {
                _context2.n = 7;
                break;
              }
              // save in normal metadata
              if (this.submitButton === 'ok') {
                this.returnPreview();
              } else if (this.submitButton === 'refuse') {
                this.returnPreviewRefuse();
              }
              _context2.n = 9;
              break;
            case 7:
              if (!(this.isChangeRequest === TYPE_CHANGE_METADA.OWENER_FLOW)) {
                _context2.n = 9;
                break;
              }
              // save in normal metadata (assign owner)
              owner = this.defaultFields[this.DEFAULT_TPL_FIELDS.OPERATOR.name].stringValue;
              owner_original = this.defaultFields_original[this.DEFAULT_TPL_FIELDS.OPERATOR.name].stringValue;
              ownerValidation = new RegExp(this.DEFAULT_TPL_FIELDS.OPERATOR.required.validation);
              ownerWasChanged = owner.match(ownerValidation) && owner_original.match(ownerValidation) && owner_original !== owner;
              ownerWasAssigned = !owner_original.match(ownerValidation) && owner.match(ownerValidation);
              env_original = this.defaultFields_original[this.DEFAULT_TPL_FIELDS.ENVIRONMENT.name].enumValue.displayName;
              env = this.defaultFields[this.DEFAULT_TPL_FIELDS.ENVIRONMENT.name].enumValue.displayName;
              isChangeEnv = env_original !== env;
              isTestEnvironment = env === 'test';
              isProdEnvironment = env === 'prod';
              isDevEnvironment = env === 'dev';
              if (!(this.isChangeRequest === TYPE_CHANGE_METADA.OWENER_FLOW && !isDevEnvironment && !this.$refs.form.validate())) {
                _context2.n = 8;
                break;
              }
              // Solo bloquea cuando falta un campo REQUERIDO (Vuetify respeta los :rules).
              // Antes usaba checkInputChanges(true), que exigía TODOS los campos —incluidos
              // los opcionales vacíos— y mostraba el mensaje aunque el formulario estuviera completo.
              this.tab = 0;
              this.dangerMessage = 'Make sure to fill all fields correctly.';
              this.dismissCountDown = this.dismissSecs;
              return _context2.a(2);
            case 8:
              // if is not have owner, and  owner was not chaged
              if (isTestEnvironment && isChangeEnv && (ownerWasChanged || ownerWasAssigned || owner)) {
                // send to aproval owner flow
                this.assignOwner();
              } else if (isProdEnvironment && isChangeEnv && (ownerWasChanged || ownerWasAssigned || owner)) {
                this.assignOwner();
              } else {
                console.log('::: saveTags ::: ONSUBMIT');
                this.saveTags(); // update tags
              }
            case 9:
              _context2.n = 11;
              break;
            case 10:
              _context2.p = 10;
              _t = _context2.v;
              console.warn(_t);
              this.onSubmit(event);
            case 11:
              return _context2.a(2);
          }
        }, _callee2, this, [[4, 10]]);
      }));
      function onSubmit(_x) {
        return _onSubmit.apply(this, arguments);
      }
      return onSubmit;
    }(),
    onCancel: function onCancel(event) {
      // if (event) {
      // event.preventDefault()
      // }
      this.$emit('cancel', null);
    },
    onClickLink: function onClickLink(file) {
      var _this7 = this;
      this.isLoading = true;
      FilesService.readFile(file.fileLink).then(function (response) {
        _this7.isLoading = false;
        if (response.success) {
          _this7.image = response.data.base64;
          _this7.dataImage = response.data;
          _this7.filename = response.data.name.split('/').pop();
          _this7.contentType = response.data.contentType;
          _this7.currentFile = {
            fileLink: response.data.base64,
            fileName: response.data.name.split('/').pop(),
            contentType: response.data.contentType
          };
        } else {
          _this7.currentFile = {
            fileLink: null,
            fileName: null,
            contentType: null
          };
          tasks.toast.error(response.message);
          // alert(response.message)
        }
      });
    },
    onFileChange: function onFileChange(event) {
      var _this8 = this;
      var file = event.target.files[0];
      var fileReader = new FileReader();
      var self = this;
      if (!file || file === undefined) {
        return;
      }
      self.isLoading = true;
      fileReader.onload = function (e) {
        var data = {
          content: e.target.result,
          filename: file.name,
          type: BUCKET_DIRECTORY_TYPES.TABLES,
          domain_source: _this8.domain_table
        };
        FilesService.uploadFile(data).then(function (res) {
          if (res['success']) {
            var _file = {
              fileLink: res['data'] && res['data']['public_url'] || '',
              fileId: res['data'] && res['data']['file_id'] || '',
              fileName: res['data'] && res['data']['filename'] || ''
            };
            self.files.push(_file);
            self.inputUploadFile = null;
            self.isLoading = false;
            _this8.updateEntryTag();
          } else {
            self.inputUploadFile = null;
            self.isLoading = false;
            tasks.toast.error(res['message']);
            // alert(res['message'])
          }
        });
      };
      fileReader.readAsDataURL(file);
    },
    deleteFile: function deleteFile(record) {
      var _this9 = this;
      this.isLoading = true;
      if (record.fileId) {
        FilesService.deleteFile(record).then(function (res) {
          _this9.isLoading = false;

          // if (res['success']) {
          //   const files = this.files
          //   this.files = files.filter(file => file.fileId !== record.fileId)
          //   this.updateEntryTag()
          // } else {
          //   alert(res['message'])
          // }
          var files = _this9.files;
          _this9.files = files.filter(function (file) {
            return file.fileId !== record.fileId;
          });
          _this9.updateEntryTag();
        }).then(function () {
          _this9.currentFile = {};
        });
      }
    },
    updateEntryTag: function updateEntryTag() {
      var _this0 = this;
      this.formatDescription();
      var toUpdate = this.tplToWork;
      var tags = toUpdate.objects.tags;
      var tableReference = toUpdate.item.tableReference;
      var relativeResourceName = toUpdate.item.relativeResourceName;
      var index_node = toUpdate.item.index_node;
      var domain_table = toUpdate.item.domain_table;
      utils.objectEmptyToNull(tags);
      this.defaultFields.files.stringValue = this.files.map(function (file) {
        return JSON.stringify(file);
      }).join(';');
      var params = {
        tags: tags,
        tableReference: tableReference,
        relativeResourceName: relativeResourceName,
        index_node: index_node,
        domain_table: domain_table
      };
      this.isLoading = true;
      AssignmentsService.updateTags(params).then(function () {
        _this0.isLoading = false;
      }).catch(function (error) {
        console.error(error);
        _this0.isLoading = false;
      });
    },
    changeEnviroment: function changeEnviroment(env) {
      var type_change = [TYPE_CHANGE_METADA.CHANGE_REQUEST, TYPE_CHANGE_METADA.UPDATE].includes(this.isChangeRequest);
      if (type_change && this.currentEnv === 'dev' && env === 'prod') {
        this.defaultFields[DEFAULT_TPL_FIELDS.ENVIRONMENT.name].enumValue.displayName = this.currentEnv;
        tasks.toast.error('It is not possible to make the pass directly to production');
        // alert('It is not possible to make the pass directly to production')
        return;
      }
    },
    clickDownloadCSV: function clickDownloadCSV() {
      var tplToWork = this.tplToWork;
      var params = {
        tplToWork: tplToWork,
        default_fields: this.defaultFields,
        tags: tplToWork.objects.tags,
        tableReference: tplToWork.item.tableReference,
        massive: false
      };
      if (this.$gtm.enabled() && window.dataLayer) {
        window.dataLayer.push({
          event: GA_EVENTS.DOWNLOAD_METADATA,
          object: 'table',
          domain_object: tplToWork.item.domain_table,
          company_code: this.companyCode,
          id_object: tplToWork.item.tableReference.projectId + '.' + tplToWork.item.tableReference.datasetId + '.' + tplToWork.item.tableReference.tableId,
          hash_email: this.stringToHash(userInfo.email),
          module: 'data_platform'
        });
      }
      var _tasks$buildDataCSV = tasks.buildDataCSV(params),
        data = _tasks$buildDataCSV.data,
        fileName = _tasks$buildDataCSV.fileName;
      tasks.saveData(data, fileName);
    },
    checkInputChanges: function checkInputChanges() {
      var all = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var changes = [];
      var value = this.__compareObjects(this.defaultFields_original, this.defaultFields, all);
      changes.push(value);
      for (var column in this.columnFields) {
        value = this.__compareObjects(this.columnFields_original[column].fields, this.columnFields[column].fields, all);
        changes.push(value);
      }
      console.log(changes);
      if (all) {
        return changes.length && changes.every(function (record) {
          return record;
        });
      } else {
        return changes.length && changes.some(function (record) {
          return record;
        });
      }
    },
    __compareObjects: function __compareObjects(object__A, object__B) {
      var all = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var keys_original = Object.keys(object__A);
      var changes = [];
      var ignore_fields = ['env', 'public', 'area_data_steward', 'bus_data_steward', 'data_owner', 'sensitive', 'primary_key', 'null', 'encrypted', 'files', 'official_source', 'tech_data_steward', 'valid_values', 'business_term', 'fieldprueba', 'upload_platform', 'upload_process', 'bus_data_steward', 'data_owner', 'tech_data_custodiam', 'tables_relationship', 'table_load_logic', 'column_load_logic', 'description2', 'description3', 'final_table'];
      for (var _i2 = 0, _keys_original = keys_original; _i2 < _keys_original.length; _i2++) {
        var key_original = _keys_original[_i2];
        var value = object__B[key_original];
        var valueOriginal = object__A[key_original];
        var stringValue = this.parseValue(value);
        var stringValueOriginal = this.parseValue(valueOriginal);
        if (ignore_fields.includes(key_original) && all) {
          continue;
        }
        if (all && stringValue !== 'Null' && stringValue !== '') {
          changes.push(true);
          continue;
        }
        console.log(key_original, ': ', stringValue, ' !== ', stringValueOriginal);
        changes.push(stringValue !== stringValueOriginal);
      }
      if (all) {
        return changes.length && changes.every(function (record) {
          return record;
        });
      } else {
        return changes.length && changes.some(function (record) {
          return record;
        });
      }
    },
    parseValue: function parseValue(obj) {
      var value = null;
      for (var _i3 = 0, _arr = ['stringValue', 'boolValue', 'enumValue']; _i3 < _arr.length; _i3++) {
        var property = _arr[_i3];
        if (typeof obj[property] !== 'undefined') {
          if (['stringValue', 'boolValue'].includes(property)) {
            value = obj[property];
          } else {
            value = obj[property].displayName;
          }
          return value;
        }
      }
      return value;
    },
    parseFiles: function parseFiles() {
      var values = this.defaultFields.files && this.defaultFields.files.stringValue.split(';');
      var files = [];
      if (!(values instanceof Array) || !values) {
        return files;
      }
      var _iterator = _createForOfIteratorHelper(values),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var value = _step.value;
          if (value && value !== 'Null') {
            try {
              files.push(JSON.parse(value));
            } catch (error) {
              console.error(error);
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return files;
    },
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    // validates user access
    fvalidUserAccess: function fvalidUserAccess() {
      if (this.tplToWork.origin) {
        if (this.tplToWork.origin === 'assignments' && this.cRoles.includes(ROLES_LIST.PLATFORM_STEWARD)) {
          this.validUserAccess = false;
        } else if (this.tplToWork.origin === 'mytables' && this.cRoles.includes(ROLES_LIST.ORG_DATA_STEWARD)) {
          this.validUserAccess = false;
        } else {
          this.validUserAccess = true;
        }
      } else if (this.cRoles.includes(ROLES_LIST.ORG_DATA_STEWARD) || this.defaultFields[this.DEFAULT_TPL_FIELDS.OPERATOR.name].stringValue === this.cEmail) {
        this.validUserAccess = false;
      }
    },
    getExecutions: function getExecutions() {
      var _this1 = this;
      this.isLoadingExecutions = true;
      var params = {
        domainTable: this.profilingRuleSelected.domainTable,
        documentId: this.profilingRuleSelected.document_id
      };
      this.$store.dispatch('data-platform/getProfilingExecutions', params).then(function () {
        _this1.isLoadingExecutions = false;
      });
    },
    isProd: function isProd() {
      return this.defaultFields[DEFAULT_TPL_FIELDS.ENVIRONMENT.name].enumValue.displayName === 'prod';
    }
  }
};